import Cookies from 'js-cookie';

export const Header = (function () {
	'use strict';

	let $menu, $menuButton, $subMenuItem, $body, $win, $header,$block;

	const DESKTOP_BREAKPOINT = 1024
	const DESKTOP_OFFSET = 170
	const MOBILE_OFFSET = 70

	const $firstBlock = $('#pxMainContent .pxblock').first();
	const $messageBanner = $('.msg-banner');
	const $messageBannerClose = $('.msg-banner__close');

	function init() {
		($menu = $('.site-header__nav .nav-items')), ($menuButton = $('.mobile-menu-button'));
		$body = $('body');
		$subMenuItem = $('.site-header .sub-menu a');
		$win = $(window);
		$header = $('.site-header');
		$block = $('.pxblock');
		events();
		check();
		messageBanner();
	}

	function messageBanner() {
		const timestamp = Date.now();

		if(!sessionStorage.getItem('dismissedMessageBanner') || window.location.pathname === "/" ){
			$messageBanner.show();
			updateFirstBlockPadding();
			$(window).resize(updateFirstBlockPadding);
		}

		$messageBannerClose.click(function() {
			sessionStorage.setItem('dismissedMessageBanner', true);
			$messageBanner.hide();
			$firstBlock.removeAttr('style');
		});
	}

	function updateFirstBlockPadding(){
		console.log('updateFirstBlockPadding');
		if($messageBanner.is(':visible')){
			$firstBlock.attr('style', 'border-top: ' + $messageBanner.outerHeight() + 'px solid transparent !important');	
		}
	}

	function scrollToEl(id) {
		const isDesktop = document.body.width >= DESKTOP_BREAKPOINT
		const offset = isDesktop ? DESKTOP_OFFSET : MOBILE_OFFSET
		if ($(id).length) {
			const scrollTop = $(id).offset().top - offset 
			$('html, body').animate({ scrollTop }, 1000);
		}
	}

	function events() {

		/*
			Update menu for mobile
		*/
		$('#menu-main-menu').find('> li.menu-item-has-children').each( function() {
			$(this).append('<a href="#" class="toggle"></a>');
		});

		$subMenuItem.each(function(){ 
			const $this = $(this)
			const isThisPage = $this[0].pathname === window.location.pathname
			if($this[0].hash.length && isThisPage) {
				$this.on('click', function(e){
					e.preventDefault()
					scrollToEl($this[0].hash)
					closeMenu()
				})
			}
		})

		$('#menu-main-menu').on('click', '.toggle', function(e) {
			e.preventDefault();

			// console.log($(this).parent().attr('class'));

			// if ( $(this).parent().hasClass('submenu--expanded') ) {
			// 	// console.log('removing class');
			// 	$(this).parent().removeClass('submenu--expanded');
			// 	$(this).blur();
			// 	return;
			// }

			// console.log('adding class');
			$(this).parent().toggleClass('submenu--expanded');

		});

		function openMenu() {
			$body.addClass('mobile-menu-open');
			$menu.addClass('open');
			$menuButton.addClass('open').attr('aria-expanded', 'true');
		}

		function closeMenu() {
			console.log('close')
			$body.removeClass('mobile-menu-open');
			$menu.removeClass('open');
			$menuButton.removeClass('open').attr('aria-expanded', 'false');
		}

		$menuButton.click(function () {
			if ($menu.hasClass('open')) {
				closeMenu()
			} else {
				openMenu()
			}
		});

		checkDistScrolled();
		$win.scroll(checkDistScrolled);
	}

	function checkDistScrolled(){
		let distScrolled = $(window).scrollTop();

		if (distScrolled > 50) {
			if (!$header.hasClass('condensed')) {
				$header.addClass('condensed');
			}
		} else {
			if ($header.hasClass('condensed')) {
				$header.removeClass('condensed');
			}
		}
	}

	function check() {
		$('.pxblock.pxblock--copy:first-child').first().addClass('pxblock-first');
		// $('.pxblock.pxblock--featured-posts:first-child').first().addClass('pxblock-first');
		// not sure what this did/where
		// $('.pxblock--copy-form:first-child').first().addClass('pxblock-first');
		$('.site-header__nav .current-menu-item .current-menu-item').removeClass('current-menu-item');
	}//end check
	return {
		init: init,
	};
})();
